export default __webpack_public_path__ + "static/media/linkedIn.89b58bd9.svg";